import { updatePageCollection } from 'redux/actions/pages/actionsPages';
import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
/**
 * gets the list of projects
 */
 export async function getLivePages(
    projectId,
    sortBy = 'title',
    order = 'asc',
    limit = 20,
    start = 0,
    query = '',
    label = [],
    exhibitorCompanyProfileId = '',
    short = '',
    getAll = '',
    type = '',
    status = '',
    startDate = '',
    endDate = '',
    timezone = '',
    updatedIds = [],
    createdIds = [],
    pageIds = [],
    excludePageIds = []
) {
    const user = store?.getState()?.user;

    // Final endpoint
    let endpoint = `${process.env.REACT_APP_MYXP_API_VIRTUAL}/v1/manager/livepages?projectId=${projectId}&sortBy=${sortBy}&sortOrder=${order}&limit=${limit}&search=${query}&filter=${label}&start=${start}&exhibitorCompanyProfileId=${exhibitorCompanyProfileId}&short=${short}&getAll=${getAll}`;
    if (type) {
        endpoint += `&type=${type}`;
    }
    if (status) {
        endpoint += `&status=${status}`;
    }
    if (startDate) {
        endpoint += `&startDate=${startDate}`;
    }
    if (endDate) {
        endpoint += `&endDate=${endDate}`;
    }
    if (timezone) {
        endpoint += `&timezone=${timezone}`;
    }
    if (updatedIds?.length) {
        endpoint += `&updatedIds=${updatedIds.join(',')}`;
    }
    if (createdIds?.length) {
        endpoint += `&createdIds=${createdIds.join(',')}`;
    }
    if (pageIds?.length) {
        endpoint += `&pageIds=${pageIds.join(',')}`;
    }
    if (excludePageIds?.length) {
        endpoint += `&excludePageIds=${excludePageIds.join(',')}`;
    }
    if (isAuthenticated() && user) {
        const response = await apiInterceptor(endpoint, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const res = await response.json();

        if (res.status) {
            store.dispatch(updatePageCollection(res.showcases));
        }

        return res;
    }
}

export async function getLivePagesDataByIds(projectId, ids) {
    const user = store?.getState()?.user;

    // Final endpoint
    let endpoint = `${process.env.REACT_APP_MYXP_API}/manager/livestream/livepages?projectId=${projectId}`;
    if (isAuthenticated() && user) {
        const response = await apiInterceptor(endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ ids }),
        });

        return await response.json();
    }
}
